import { useMemo } from 'react';

import { useAppStore, type IAppStore } from '@/store';
import useLibrarySectionsQuery from '@/hooks/queries/useLibrarySectionsQuery';

import type { LibraryItem } from '@/types';

const selector = (store: IAppStore) => ({
  activeTabSlug: store.activeTabSlug,
  entrySlug: store.presetFeedEntrySlug,
});

const usePresetFeedData = (): {
  items: LibraryItem[];
  initialIndex: number;
  isLoading: boolean;
} => {
  const { activeTabSlug, entrySlug } = useAppStore(selector);
  const { data: sections, isPending } = useLibrarySectionsQuery();

  return useMemo(() => {
    const items =
      sections?.find((section) => section.slug === activeTabSlug)?.items ?? [];
    const foundIndex = items.findIndex((item) => item.slug === entrySlug);
    return {
      items,
      initialIndex: foundIndex >= 0 ? foundIndex : 0,
      isLoading: Boolean(activeTabSlug) && isPending,
    };
  }, [sections, entrySlug, activeTabSlug, isPending]);
};

export default usePresetFeedData;
